import axios from "axios";

export default {
  props: {
    advertiserAccountId: {
      type: [ String, Number ],
      default: 1009
    },
    keyword: {
      type: String,
      default: ""
    },
    perPage: {
      type: [ String, Number ],
      default: 5
    },
    country: {
      type: String,
      default: "us"
    },
    postalCode: {
      type: String,
      default: ""
    },
    manualTriggerContentView: {
      type: Boolean,
      default: false
    },
    triggerContentView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ads: [],
      page: 1,
      loading: true,
      loaded: false,
      disableSeeMore: true,
      hideSeeMore: false,
      nextPageRequestUrl: "",
      productCategory: ""
    };
  },
  watch: {
    triggerContentView: function(val) {
      if(val === true && this.manualTriggerContentView) {
        this.jfpTrack("ContentView", {
          advertiser_account_id: this.advertiserAccountId,
          // advertiser_channel_1: XXX,
          // advertiser_channel_2: XXX,
          // advertiser_channel_3: XXX
        });
      }
    }
  },
  computed: {},
  methods: {
    extensionInit() {
      return new Promise((resolve) => {
        resolve();
      });
    },
    getAds(options = {}) {
      return new Promise((resolve, reject) => {
        // If not internal publisher account, dont allow access
        if(!["10001", "10002", "10003"].includes(this.publisherAccountId.toString())) {
          reject();
        }

        this.disableSeeMore = true;
        this.loading = true;

        let preventLoadEvents = ('preventLoadEvents' in options ? options.preventLoadEvents : false);

        let url = this.nextPageRequestUrl !== "" ? this.nextPageRequestUrl : "https://api-v2.jumpfeed.com/network/publisher/ads";
        let params = this.nextPageRequestUrl !== "" ? {} : {
          keyword: ('keywordOverride' in options ? options.keywordOverride : this.keyword),
          advertiser_account_id: this.advertiserAccountId,
          per_page: this.perPage,
          postal_code: this.postalCode ? this.postalCode : this.visitorLocation.postalCode,
          country: this.country && ["us","ca","au"].includes(this.country) ? this.country : "us",
          category: this.productCategory,
          serve_url: window.location.href,
          referer_url: document.referrer
        };

        if(this.advertiserAccountId == 1027 || this.advertiserAccountId == 1062) {
          params.make = ('make' in options ? options.make : (this.urlParams.get('make') ?? ""));
          params.model = ('model' in options ? options.model : (this.urlParams.get('model') ?? ""));
          params.keyword = (params.make.length > 0 && params.model.length > 0) ? params.make + " " + params.model : "";
          if (this.urlParams.get('awcatid')) {
            params.aw_category_id = this.urlParams.get('awcatid');
          }
          if (this.urlParams.get('awrawresponse')) {
            params.raw_response = 1;
          }
        }

        if(this.advertiserAccountId == 1013 && this.urlParams.get("ttt") && this.urlParams.get("ttt") == 1) {
          params.new_token = 1;
        }

        if(this.urlParams.get("mnv2")) {
          params.mnv2 = 1;
        }

        if(this.urlParams.get("jfoid") || this.urlParams.get("utm_campaign")) {
          params.offer_id = this.urlParams.get("jfoid") || this.urlParams.get("utm_campaign");
        }

        let vm = this;
        axios.get(url, { params })
          .then(function (response) {
            let ads = response.data.data;

            vm.nextPageRequestUrl = response.data.links.next;

            if(ads.length == 0) {
              if(!preventLoadEvents) {
                let noContentLoadedEventData = {
                  advertiser_account_id: vm.advertiserAccountId
                };
                vm.triggerNoContentLoaded(noContentLoadedEventData);
              }
            }
            else {
              // Track "ContentView" event for the keyword after the first page of ads
              if(vm.ads.length === 0 && !vm.manualTriggerContentView && !preventLoadEvents) {
                vm.jfpTrack("ContentView", {
                  advertiser_account_id: vm.advertiserAccountId,
                  // advertiser_channel_1: XXX,
                  // advertiser_channel_2: XXX,
                  // advertiser_channel_3: XXX
                });
              }

              ads.forEach((ad, i) => {
                if(!('ad_holder_extra_attributes' in ad)) {
                  ads[i].ad_holder_extra_attributes = '';
                }
                ads[i].container_attributes = ads[i].ad_holder_extra_attributes.length == 0 ? {} : ads[i].ad_holder_extra_attributes.split(' ').reduce(function(result, item) {
                  result[item.split('=')[0]] = item.split('=')[1].replaceAll('"', "");
                  return result;
                }, {});
              });

              vm.ads = vm.ads.concat(ads);
            }

            vm.loaded = true;
            vm.loading = false;

            if(!preventLoadEvents) {
              vm.$emit('ads-loaded', ads);
            }

            if(vm.advertiserAccountId == 1009) {
              let pixels = response.data.metadata.pixels;
              vm.attachMediaNetPixels(pixels);
            }

            resolve(ads);
          })
          .catch(function (error) {
            console.log(error);
            vm.hide = true;
            vm.loaded = true;
            vm.loading = false;
            vm.disableSeeMore = false;
            if(!preventLoadEvents) {
              vm.triggerNoContentLoaded({
                advertiser_account_id: vm.advertiserAccountId,
                advertiser_channel_1: 0
              });
            }
            resolve([]);
          });
      });
    },
    attachMediaNetPixels(pixelsData) {
      // Attach medianet scripts/pixels
      let headPixelScript = document.createElement("script");
      headPixelScript.type = "text/javascript";
      headPixelScript.innerHTML = pixelsData.javascript.head_script_content;
      document.head.appendChild(headPixelScript);

      let headPixelScriptExternal = document.createElement("script");
      headPixelScriptExternal.type = "text/javascript";
      headPixelScriptExternal.src = pixelsData.javascript.head_script_url;
      document.head.appendChild(headPixelScriptExternal);

      let bodyPixelScript = document.createElement("script");
      bodyPixelScript.type = "text/javascript";
      bodyPixelScript.innerHTML = pixelsData.javascript.body_script_content;
      let bodyScriptContainer = document.getElementById(pixelsData.javascript.body_script_container_id);
      if(!bodyScriptContainer){
        bodyScriptContainer = document.createElement('div');
        bodyScriptContainer.setAttribute("id", pixelsData.javascript.body_script_container_id);
        bodyScriptContainer.classList.add("--bg-footer");
        document.body.appendChild(bodyScriptContainer);
      }
      bodyScriptContainer.appendChild(bodyPixelScript);

      let pixelImage = document.createElement("img");
      pixelImage.width = 1;
      pixelImage.height = 1;
      pixelImage.border = 0;
      pixelImage.style.display = "none";
      pixelImage.src = pixelsData.image;
      document.body.appendChild(pixelImage);

      // Attach medianet Hotjar script
      let brandDomainHotjarIdMap = {
        'carinsider.co': 5016208,
        'autosreviewed.co': 5016190,
        'autosreviewed.net': 5064475,
        'urbanconsumersguide.com': 5016204,
        'motordaily.co': 5016188,
        'topmotorsearch.com': 5016191,
        'consumerbuzz.co': 5016213,
        'carscience.com': 5016198,
        'factswhizz.com': 5016200,
        'fourwheelz.co': 5016215,
        'jobnamic.com': 0,
        'carzario.com': 5016218,
        'carzario.net': 5016218,
        'autoshark.net': 5016196,
        'automobileaccess.co': 5016214,
        'carzarli.com': 5016216,
        'carzarli.net': 5016216,
        'motorwizard.co': 5016202,
        'automobileinsiders.com': 5016206,
        'autoinsider360.com': 5016211
      };

      let hotjarScript = document.createElement("script");
      hotjarScript.innerHTML = "(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:" + brandDomainHotjarIdMap[this.domain] + ",hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=')";
      document.head.appendChild(hotjarScript);


      // Attach Yahoo script/pixel
      if('yahoo' in pixelsData) {
        let yahooHeadScript = document.createElement("script");
        yahooHeadScript.innerHTML = pixelsData.yahoo.post_head_start;
        document.head.appendChild(yahooHeadScript);

        let yahooBodyScriptContainer = document.createElement('div');
        yahooBodyScriptContainer.innerHTML = pixelsData.yahoo.pre_body_end;
        yahooBodyScriptContainer.style.display = "none";
        document.body.appendChild(yahooBodyScriptContainer);
      }
    },
    triggerAdClick(ad) {
      this.jfpTrack("ContentClick", {
        publisher_channel_2: "jfkw_" + ad.keyword,
        advertiser_account_id: ad.advertiser_account_id,
        advertiser_external_content_id: ad.external_ad_id,
        event_value: ad.payout_value,
        advertiser_channel_1: ad.host_url
      });

      sessionStorage.setItem(window.location.hostname + "-adClicked", ad.advertiser_account_id);

      if (this.advertiserAccountId != 1009) {
        if (this.productCategory == "jobs") {
          ad.destination_url = "https://ad.jumpfeed.com/out.php?d=" + encodeURIComponent(ad.destination_url);
        } else {
          ad.destination_url = "https://ad.carscience.com/out.php?d=" + encodeURIComponent(ad.destination_url);
        }
      }

      if(this.urlParams.get("pnt") == 1 || this.isFacebookUserAgent()) {
        window.location.href = ad.destination_url;
      } else {
        window.open(ad.destination_url, "_blank");
      }
    }
  }
};